import { IFIReportTypeItem } from './IFIReportTypeItem'

export const DailyInspectionInspection = new IFIReportTypeItem({
  id: 'C56D9129-3BA6-4C2B-9B6C-52ED57C6F0F7',
  classType: 'DailyInspectionInspection',
  label: 'inspectionId',
  type: 'Inspection',
  importRules: [
    'The inspection must not be deleted',
    'Unresolved Issues Associated with this Work must be set to Yes',
    'The New issue must be enabled',
  ],
  defaultMessages: {
    missing: 'Missing Geometry',
  } as const,
})

export const DailyInspectionControlPoint = new IFIReportTypeItem({
  id: 'A1CC698F-9FB4-4F73-96C2-4A0F1AF72E67',
  classType: 'DailyInspectionControlPoint',
  label: 'controlPointId',
  type: 'Control Point',
  importRules: [
    'The inspection must not be deleted',
    'Unresolved Issues Associated with this Work must be set to Yes',
    'The New issue must be enabled',
  ],
  defaultMessages: {
    missing: 'Missing Geometry',
  } as const,
})

export const DailyInspectionPunchList = new IFIReportTypeItem({
  id: '2F915EF5-4E44-4893-B478-D0E7EF225DBC',
  classType: 'DailyInspectionPunchList',
  label: 'punchListId',
  type: 'Punch List',
  importRules: ['The inspection must not be deleted'],
})

export const ConcreteTest = new IFIReportTypeItem({
  id: '33EBE872-4039-40EB-9B7D-330E44D6E6B9',
  classType: 'ConcreteTest',
  label: 'fieldNumber',
  type: 'Concrete Test',
  importRules: [
    'The test must not be deleted',
    'The test set must not be deleted',
    'The test must fail the percent air check, slump check, or temperature check',
  ],
  defaultMessages: {
    ambient: 'Air Temp below Minimum Ambient Air Temperature',
    highTemp: 'High Temperature',
    lowTemp: 'Low Temperature',
    noTemp: 'No Temperature',
    highSlump: 'High Slump',
    lowSlump: 'Low Slump',
    noSlump: 'No Slump',
    highAir: 'High Percent Air',
    lowAir: 'Low Percent Air',
    noAir: 'No Percent Air',
  } as const,
})

export const Lot = new IFIReportTypeItem({
  id: 'DB13C15D-9B53-4893-A69E-8C35887B96C6',
  classType: 'Lot',
  label: 'lotId',
  type: 'Density Lot',
  defaultMessages: {
    count: 'Lot did not contain minimum required number of tests',
    proctor: 'Lot was closed without a Global Proctor Value',
    lotCompaction: 'Lot compaction did not exceed material percent compaction',
    testCompaction:
      'Test compaction did not exceed material percent compaction',
  } as const,
})

export const AsphaltLot = new IFIReportTypeItem({
  id: '0D0F32C0-E423-46C5-A3A9-10A2BE0768FC',
  classType: 'AsphaltLot',
  label: 'asphaltLotId',
  type: 'Asphalt Lot',
})

export const DensityTest = new IFIReportTypeItem({
  id: '188FDAAD-6924-43CF-BFC5-D716AC18F2DB',
  classType: 'DensityTest',
  label: 'testId',
  type: 'Density Test',
  defaultMessages: {
    message: 'Test compaction did not exceed material percent compaction',
  } as const,
})
